import { FormData, FormErrors, RunAllValidators, SetFormErrors } from '@/hooks';
import { FormInputNameRegister } from '@/features/register/type';
import { ContactConfirmationChannel } from '@/model/ContactConfirmationResponse';

export enum RegisterStep {
  PERSONAL_DATA = 0,
  CONTACT = 1,
  CONTACT_CONFIRMATION = 2,
  ADDRESS = 3,
  SECURITY = 4,
  TERMS = 5,
}

export const REGISTER_STEP_FIELDS: Record<RegisterStep, FormInputNameRegister[]> = {
  [RegisterStep.PERSONAL_DATA]: [FormInputNameRegister.document, FormInputNameRegister.name],
  [RegisterStep.CONTACT]: [FormInputNameRegister.email, FormInputNameRegister.phone],
  [RegisterStep.CONTACT_CONFIRMATION]: [FormInputNameRegister.confirmationCode],
  [RegisterStep.ADDRESS]: [
    FormInputNameRegister.zipCode,
    FormInputNameRegister.state,
    FormInputNameRegister.city,
    FormInputNameRegister.district,
    FormInputNameRegister.street,
    FormInputNameRegister.addressnumber,
  ],
  [RegisterStep.SECURITY]: [FormInputNameRegister.password, FormInputNameRegister.confirmPassword],
  [RegisterStep.TERMS]: [FormInputNameRegister.terms],
};

interface ValidateRegisterFieldsParams {
  fields: FormInputNameRegister[];
  formData: FormData;
  formErrors: FormErrors;
  runAllValidators: RunAllValidators;
  setFormErrors: SetFormErrors;
}

export const validateRegisterFields = ({
  fields,
  formData,
  formErrors,
  runAllValidators,
  setFormErrors,
}: ValidateRegisterFieldsParams): boolean => {
  const allErrors = runAllValidators();
  const fieldsErrors = fields.reduce<FormErrors>(
    (errors, field) => ({
      ...errors,
      [field]: allErrors[field] || null,
    }),
    {},
  );

  if (
    fields.includes(FormInputNameRegister.confirmPassword) &&
    formData[FormInputNameRegister.password] !== formData[FormInputNameRegister.confirmPassword]
  ) {
    fieldsErrors[FormInputNameRegister.password] = ['Senhas divergentes!'];
    fieldsErrors[FormInputNameRegister.confirmPassword] = ['Senhas divergentes!'];
  }

  setFormErrors({
    ...formErrors,
    ...fieldsErrors,
  });

  return fields.every(field => !fieldsErrors[field]);
};

export const formatContactConfirmationDestination = (
  channel: ContactConfirmationChannel,
  email: string,
  phone: string,
): string => {
  if (channel === ContactConfirmationChannel.EMAIL) {
    const [user = '', domain = ''] = email.split('@');
    const visibleUser = user.slice(0, 2);
    const maskedUser = `${visibleUser}${'*'.repeat(Math.max(3, user.length - visibleUser.length))}`;
    return `e-mail ${maskedUser}@${domain}`;
  }

  const phoneNumbers = phone.replace(/\D/g, '');
  return `WhatsApp com final ${phoneNumbers.slice(-4)}`;
};
